"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.date.to-string.js");
require("react-date-range/dist/styles.css");
require("react-date-range/dist/theme/default.css");
var _dateFns = require("date-fns");
var locales = _interopRequireWildcard(require("date-fns/locale"));
var _reactDateRange = require("react-date-range");
var _reactPortal = require("react-portal");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _formElements = require("@evidation/form-elements");
var _reactI18next = require("react-i18next");
var _LanguageContext = require("../../contexts/LanguageContext");
var _components = require("./components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); } // main style file
// theme css file
var getLocale = function getLocale() {
  var currentLocale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'en-US';
  var language = locales[currentLocale.replace('-', '')];
  if (language) {
    return language;
  }
  return locales.enUS;
};
var OutsideAlerter = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
    _ref$onOutsideClick = _ref.onOutsideClick,
    onOutsideClick = _ref$onOutsideClick === void 0 ? function () {} : _ref$onOutsideClick;
  var wrapperRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var handleClickOutside = function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onOutsideClick();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      return document.removeEventListener('mousedown', handleClickOutside);
    };
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: wrapperRef
  }, children);
});
var DateComponent = /*#__PURE__*/function (_React$Component) {
  function DateComponent() {
    var _this;
    (0, _classCallCheck2["default"])(this, DateComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, DateComponent, [].concat(args));
    (0, _defineProperty2["default"])(_this, "state", {
      touched: false
    });
    (0, _defineProperty2["default"])(_this, "onChange", function (date, closePortal) {
      var formattedDate = _this.props.formatSubmit(date);
      _this.props.onChange(formattedDate);
      closePortal();
      _this.setState({
        touched: true
      });
    });
    (0, _defineProperty2["default"])(_this, "getValue", function () {
      var value = _this.props.value;
      if ((0, _dateFns.isDate)(value) && (0, _dateFns.isValid)(value)) return value;
      var parsedValue = _this.props.parseValue(value, _this.props.submitFormatString);
      return (0, _dateFns.isDate)(parsedValue) && (0, _dateFns.isValid)(parsedValue) ? parsedValue : undefined;
    });
    return _this;
  }
  (0, _inherits2["default"])(DateComponent, _React$Component);
  return (0, _createClass2["default"])(DateComponent, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        error = _this$props.meta.error,
        name = _this$props.name,
        label = _this$props.label,
        options = _this$props.options,
        disabled = _this$props.disabled,
        language = _this$props.i18n.language;
      var value = this.getValue();
      return /*#__PURE__*/_react["default"].createElement(_reactPortal.PortalWithState, {
        closeOnOutsideClick: true,
        closeOnEsc: true
      }, function (_ref2) {
        var openPortal = _ref2.openPortal,
          closePortal = _ref2.closePortal,
          isOpen = _ref2.isOpen,
          portal = _ref2.portal;
        return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label && /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: name
        }, label), /*#__PURE__*/_react["default"].createElement("input", {
          type: "text",
          className: "datePicker",
          value: value ? _this2.props.formatDisplay(value) : '',
          placeholder: _this2.props.placeholder,
          onClick: openPortal,
          style: {
            cursor: disabled ? 'default' : 'pointer'
          },
          readOnly: true,
          disabled: disabled
        }), _this2.state.touched && error && /*#__PURE__*/_react["default"].createElement(_formElements.InputError, null, error), portal( /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.Modal.Bg, null), /*#__PURE__*/_react["default"].createElement(_components.Modal, null, /*#__PURE__*/_react["default"].createElement(OutsideAlerter, {
          onOutsideClick: closePortal
        }, label && /*#__PURE__*/_react["default"].createElement("label", {
          htmlFor: name
        }, label), /*#__PURE__*/_react["default"].createElement(_reactDateRange.Calendar, (0, _extends2["default"])({
          date: value,
          onChange: function onChange(data) {
            return _this2.onChange(data, closePortal);
          },
          locale: getLocale(language)
        }, options)), /*#__PURE__*/_react["default"].createElement("button", {
          onClick: closePortal
        }, "Cancel"))))));
      });
    }
  }]);
}(_react["default"].Component);
DateComponent.defaultProps = {
  label: undefined,
  value: new Date(),
  options: {},
  placeholder: "Click to select a date",
  parseValue: function parseValue(value, date_format) {
    return (0, _dateFns.parse)(value, date_format, new Date());
  },
  formatSubmit: function formatSubmit(date) {
    return (0, _dateFns.format)(date, 'yyyy-MM-dd');
  },
  formatDisplay: function formatDisplay(date) {
    return (0, _dateFns.format)(date, 'yyyy-MM-dd');
  },
  submitFormatString: 'yyyy-MM-dd'
};
DateComponent.propTypes = {
  onChange: _propTypes["default"].func.isRequired,
  options: _propTypes["default"].object,
  parseValue: _propTypes["default"].func,
  formatDisplay: _propTypes["default"].func,
  formatSubmit: _propTypes["default"].func
};
var DateComponentWithTranslation = (0, _reactI18next.withTranslation)(_LanguageContext.curiousPandaNamespace)(DateComponent);
DateComponentWithTranslation.handlesErrorDisplay = true;
var _default = exports["default"] = DateComponentWithTranslation;